import React from 'react';
import { ApolloError, useApolloClient, useMutation } from '@apollo/client';

// import FacebookLogin from 'components/buttons/FacebookLogin';
// import SignFormsContainer from 'components/forms/styled/SignFormsContainer';
import Url from 'components/Url';
import { withFlashMessages } from 'components/FlashMessages';
import { afterSignRedirect } from 'utils/navigation';
import { SignUpFormFields } from 'components/forms/SignUpForm/types';
import { withTranslation } from 'lib/i18n';
import { SignUpMutation, SignUpMutationVariables } from 'types/graphql';

import asyncValidate from './asyncValidate';
import SIGN_UP_MUTATION from './mutations/signUp';
import { FORM_ID } from './constants';
import Form from './composeForm';
import { SignUpFormProps } from './types';

const SignUpForm: React.FC<SignUpFormProps> = props => {
  const [mutate] = useMutation<SignUpMutation, SignUpMutationVariables>(
    SIGN_UP_MUTATION,
  );
  const client = useApolloClient();

  const handleCompleted = (): void => {
    afterSignRedirect();
  };

  const handleError = (error: ApolloError): ApolloError => {
    props.showFlashMessage(
      Array.isArray(error) ? error[0].message : error.message,
      {
        type: 'danger',
      },
    );

    return error;
  };

  const handleSignUp =
    (source?: number) => (variables: Record<string, unknown>) =>
      mutate({ variables: { ...(variables as SignUpFormFields), source } })
        .then(() => handleCompleted())
        .catch((error: ApolloError) => handleError(error));

  /*
  <SignFormsContainer>
    <FacebookLogin label={props.t('facebookLogin.signUp')} />
  </SignFormsContainer>
  */
  return (
    <Url>
      {url => (
        <>
          <Form
            asyncValidate={!url.query.email ? asyncValidate(client) : undefined}
            initialValues={
              url.query.email
                ? {
                    email: decodeURIComponent(url.query.email.toString()),
                  }
                : undefined
            }
            id={FORM_ID}
            i18n={props.i18n}
            t={props.t}
            onSubmit={handleSignUp(
              url.query.source
                ? parseInt(url?.query.source.toString(), 10)
                : undefined,
            )}
          />
        </>
      )}
    </Url>
  );
};

export default withTranslation('forms')(withFlashMessages(SignUpForm));
